export default __webpack_public_path__ + "static/media/green-marker.104cdd0f.svg";